import { FC, HTMLAttributes } from "react";
import { useStyles } from "./ShopAvatar.style";
import { Button, Typography, TypographyVariant, GemNumber } from "@onmo/ui";
import {
  Inventory,
  InventoryAvatarData,
  InventoryStatus,
} from "@onmo/graphql/graphql";
import Avatar from "../Avatar/Avatar";
import { useAppDispatch } from "../../../hooks";
import { addPopupQueue } from "../../../slices/popup";
import { setSelectedInventory } from "../../../slices/shop";
import { PopupType } from "../../../constants/popup";
import { useApplyInventory } from "../../../hooks/resolvers/useShopMutation";
import { useTranslation } from "react-i18next";

interface IShopAvatarProps {
  inventory: Inventory;
  isUsing?: boolean;
}

export const ShopAvatar: FC<
  IShopAvatarProps & HTMLAttributes<HTMLDivElement>
> = (props) => {
  const { inventory, isUsing, ...otherProps } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const applyInventory = useApplyInventory(inventory);
  const inventoryAvatar = inventory?.data as InventoryAvatarData;

  const onClickCard = () => {
    if (inventory.isPurchased) return;
    dispatch(addPopupQueue({ type: PopupType.PurchaseInventory }));
    dispatch(setSelectedInventory({ selectedInventory: inventory }));
  };

  const onClickEquip = () => {
    if (isUsing) return;
    applyInventory();
  };

  const renderAction = () => {
    if (inventory.isPurchased) {
      return (
        <Button
          size="small"
          variant="outlined"
          fullWidth
          disabled={isUsing}
          onClick={onClickEquip}
        >
          {isUsing ? t("using") : t("equip")}
        </Button>
      );
    } else if (inventory.status === InventoryStatus.Restricted) {
      return (
        <Typography variant={TypographyVariant.BodyB5Bold} lines={1}>
          {t("premium")}
        </Typography>
      );
    } else if (!inventory?.costs?.length) {
      return (
        <Typography variant={TypographyVariant.BodyB5Bold}>
          {t("free")}
        </Typography>
      );
    } else return <GemNumber amount={inventory.costs[0].amount} gemSize={16} />;
  };

  return (
    <div className={classes.root} onClick={onClickCard} {...otherProps}>
      <Avatar url={inventoryAvatar?.url} size="l" />
      {renderAction()}
    </div>
  );
};

export default ShopAvatar;
